import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { WitholdingTaxModel } from 'src/app/core/models/masters/witholding-tax.model';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';

@Component({
  selector: 'app-tds-popup',
  templateUrl: './tds-popup.component.html',
  styleUrls: ['./tds-popup.component.css']
})
export class TdsPopupComponent extends GenericListView<any> {

  displayedColumns: string[] = ['name', 'remarks', 'taxCode', 'taxSum', 'lineGross'];
  dataSource: any = [
    {}
  ];
  tdsArray:any=[];

  local_data: any;
  constructor(public dialogRef: MatDialogRef<any>,
    
    public agenericRepositoryForCfl: GenericService<any>,
    public routerForCfl: Router, private dbService: NgxIndexedDBService,
    public matDialogforCfl: MatDialog, private http: HttpClient, public  matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<any>>, dialog: MatDialog, agenericRepository: GenericService<any>,
    @Inject(MAT_DIALOG_DATA) private data: any, router: Router) {
      super(agenericRepository, router);
    this.local_data = { ...data };
    this.tdsArray=[...this.tdsArray,{"wtCode":null}]

  }

  addTDSRow() {

 this.tdsArray=[...this.tdsArray,{"wtCode":null}]
  }


  onOpenDropDown(value: any,index:number) {
    let genCFL = new GenericCflViewComponent<any>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (value == 'TDS') {
      genCFL.setCflTitle = "Select TDS";
      genCFL.setCflViewDataSourceURL = 'WithholdingTaxCodes/GetWithholdingTaxCodesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['wtCode', 'wtName', 'rate','effectiveFrom','category','inactive'];
      // genCFL.setCflSelectedData = this.selectedData;
      genCFL.setCFLIsCancel = false
      genCFL.setSortColumn = "WTCode";

    }



    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {

      if (res != undefined && res.event != undefined) {
        if (value == 'TDS') {
         this.tdsArray[index].wtCode=res.event.wtCode;

        }
      }
    })
  }
  onSave(){
    this.dialogRef.close({ event: true, value: this.tdsArray });
  }
}
